import classnames from 'classnames';
import type { JSX } from 'react';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { AnimatedChevronIcon } from '../../BasicComponents/Icons';
import { HEADER_HEIGHT } from '../PlayerSidebar';
import { HideButton } from './HideButton';
import type { ItemStyle } from './types';

type Props = {
  label: string;
  style: ItemStyle;
  isOpen: boolean;
  allHidden: boolean;
  onToggle: () => void;
  onHide: () => void;
  onUnhide: () => void;
};

// Collapsible header of a sidebar section whose items can be hidden all at once.
export function SidebarSectionHeader({
  label,
  style,
  isOpen,
  allHidden,
  onToggle,
  onHide,
  onUnhide,
}: Props): JSX.Element {
  return (
    <div
      className={classnames('starter-list-header', { open: isOpen })}
      style={{
        ...style,
        height: HEADER_HEIGHT,
        zIndex: 1000 + (style.zIndex || 0),
      }}
    >
      <div className="starter-list-header-item" {...onClickGenerator(onToggle)}>
        <AnimatedChevronIcon isOpen={isOpen} />
        &nbsp;
        <div className="starter-list-header-item-label">{label}</div>
        <HideButton allHidden={allHidden} onHide={onHide} onUnhide={onUnhide} />
      </div>
    </div>
  );
}
